export enum EExpands {
  Full = 'full',
  Block = 'block',
  Default = 'default'
}
